export default function WhiteBoard({ children, className }) {
    return (
        <div className={`flex flex-col gap-8 bg-white dark:bg-black rounded-lg lg:p-5 p-2 ${className} my-2`} >
            {children}
        </div >
    )
}